export default __webpack_public_path__ + "static/media/cover1.88e1d4db.jpg";